import { OpportunityDocumentType } from './opportunity-document-type';

export interface OpportunityDocumentTypeRes {
  count: number;
  opportunityDocumentTypes: Array<OpportunityDocumentType>;
}
